import {request as zoeRequest, RequestOptions} from '@zoefin/utils';

function handleRequest<T = any>(
  url: string,
  options?: RequestOptions,
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    zoeRequest<T>(url, {
      withErrorManipulation: true,
      removeDataObject: true,
      ...options,
    })
      .then(resolve)
      .catch(reject);
  });
}

function request<T = any>(url: string, options?: RequestOptions): Promise<T> {
  return handleRequest(url, options);
}

export default request;

// `options` attribute MUST be optional
// To be deprecated alongside swr
export function swrRequest<T = any>(
  url: string,
  options?: RequestOptions,
): Promise<T> {
  return handleRequest(url, options);
}
